module.exports = __webpack_public_path__ + "static/media/hellboy-punch.2ef932c8.png";